import { isNil, isObject, set, keys, get as lodashGet } from 'lodash-es';
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const formItemNameBlackList = ['parentNode'];
// default form item id prefix.
const defaultItemNamePrefixCls = 'form_item';
export function getFieldId(namePath, formName) {
    if (!namePath)
        return undefined;
    const isIllegalName = formItemNameBlackList.includes(namePath);
    if (formName) {
        return `${formName}_${namePath}`;
    }
    return isIllegalName ? `${defaultItemNamePrefixCls}_${namePath}` : namePath;
}
export function replaceMessage(template, kv) {
    return template.replace(/\{\w+\}/g, (str) => {
        const key = str.slice(1, -1);
        return `${kv[key]}`;
    });
}
export function getValidateRules(rules, context) {
    const { label, name, validateMessages } = context;
    const rulesMap = {};
    rules?.forEach((rule) => {
        const { message, validator, required, ...rest } = rule;
        Object.keys(rest).forEach((key) => {
            const mergedKey = key;
            const value = rest[mergedKey];
            const defaultMessage = validateMessages[mergedKey];
            const mergedMessage = message ??
                replaceMessage(defaultMessage, {
                    name: typeof label === 'string' ? label : name,
                    ...rest,
                });
            rulesMap[key] = { value, message: mergedMessage };
        });
        if (!isNil(required)) {
            let mergedRequired = required;
            let mergedMessage = message;
            if (typeof required === 'string') {
                mergedRequired = true;
                if (!message) {
                    mergedMessage = required;
                }
            }
            const defaultMessage = validateMessages.required;
            if (!mergedMessage) {
                mergedMessage = replaceMessage(defaultMessage, {
                    name: typeof label === 'string' ? label : name,
                });
            }
            rulesMap.required = { value: mergedRequired, message: mergedMessage };
        }
        if (validator && typeof validator === 'function') {
            rulesMap.validate = async (fieldValue, values) => {
                try {
                    const result = await validator(fieldValue, values);
                    return await Promise.resolve(result);
                }
                catch (e) {
                    // For Promise.reject('xxxx')
                    if (typeof e === 'string') {
                        return await Promise.resolve(e);
                    }
                    return await Promise.resolve(e.message);
                }
            };
        }
    });
    return rulesMap;
}
/* why not use lodash.get
 when path is [], lodash.get return undefined, but we need get origin value
 for example:
  lodash.get({a: b: {c: 'd'}}, []) => undefined
  get({a: b: {c: 'd'}}, []) => {a: b: {c: 'd'}}
 */
export function get(entity, path) {
    let current = entity;
    for (let i = 0; i < path.length; i += 1) {
        if (current === null || current === undefined) {
            return undefined;
        }
        current = current[path[i]];
    }
    return current;
}
function createEmpty(source) {
    return (Array.isArray(source) ? [] : {});
}
export function merge(...sources) {
    let clone = createEmpty(sources[0]);
    sources.forEach((src) => {
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = get(src, path);
            const isArr = Array.isArray(value);
            if (isArr || (isObject(value) && !(value instanceof Date))) {
                // Only add not loop obj
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = get(clone, path);
                    if (isArr) {
                        // Array will always be override
                        clone = set(clone, path, []);
                    }
                    else if (!originValue || typeof originValue !== 'object') {
                        // Init container if not exist
                        clone = set(clone, path, createEmpty(value));
                    }
                    keys(value).forEach((key) => {
                        internalMerge([...path, key], loopSet);
                    });
                }
            }
            else {
                clone = set(clone, path, value);
            }
        }
        internalMerge([]);
    });
    return clone;
}
function getKeyPaths(field, parentKey = '') {
    return Object.keys(field).reduce((paths, key) => {
        const fullPath = `${parentKey}.${key}`;
        const f = lodashGet(field, key);
        if (typeof f === 'object' && f && !f._f) {
            return paths.concat(getKeyPaths(f, `${fullPath}`));
        }
        return paths.concat(fullPath);
    }, []);
}
export function getNameListFromFields(fields) {
    const nameList = [];
    const fieldsKeys = Object.keys(fields);
    for (let i = 0; i < fieldsKeys.length; i++) {
        const key = fieldsKeys[i];
        const field = lodashGet(fields, key);
        if (field) {
            const { _f } = field;
            if (_f) {
                nameList.push(key);
            }
            else {
                nameList.push(...getKeyPaths(field, key));
            }
        }
    }
    return nameList;
}
